import React from 'react';
import { useI18n } from './I18n';

export const usePageTitleUpdateEffect = (title: string): void => {
  const i18n = useI18n();
  React.useEffect(() => {
    document.title = i18n.LABELS.localize('page_title', undefined, { title });
  }, []);
};
